module.exports = __webpack_public_path__ + "toBride1-jp-r-w.4f27dbfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-jp-r-w.jpg
// module id = 4Cak
// module chunks = 0